'use strict';

import GoogleMap from './../common/GoogleMap';

export default function objectMap () {
    const OBJECT_MAP_SELCTOR = '.js-object-map';

    let $map = $(OBJECT_MAP_SELCTOR);

    if (!$map.length) {
        return;
    }

    let lat = $map.attr('data-lat'),
        lng = $map.attr('data-lng'),
        $gMap,
        $gMapStreetView,
        $gMapPosition;

    let objectMap = new GoogleMap({
        mapSelector: OBJECT_MAP_SELCTOR,
        callback () {
            $gMap = this.$gMap;
            $gMapPosition = new google.maps.LatLng(lat, lng);

            $gMap.setCenter($gMapPosition);

            objectMap.setMarker({
                lat: lat,
                lng: lng,
                icon: {
                    url: '/v2/img/object-map-marker.png',
                    Size: new google.maps.Size(39, 30),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(18, 30)
                }
            });

            $gMapStreetView = this.$gMap.getStreetView();
            $gMapStreetView.setPosition($gMapPosition);
        }
    });

    let $mapMode = $('.js-object-map-mode');

    if (!$mapMode.length) {
        return;
    }

    $mapMode.on('click', function () {
        let $this = $(this);

        if ($this.hasClass('active')) {
            return;
        }

        $mapMode.removeClass('active');

        $this.addClass('active');

        if ($gMapStreetView) {
            if ($this.attr('data-mode') === 'street') {
                $gMapStreetView.setVisible(true);
                $gMapStreetView.setPov({
                  heading: 265,
                  pitch: 0
                });
                $gMapStreetView.setPano(null);
            } else {
                $gMapStreetView.setVisible(false);
                $gMap.setCenter($gMapPosition);
            }
        }
    });
}
